var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGbp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    id: "canvas_background",
    height: 402,
    width: 402,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_19"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(1.0326606544719077,0,0,1.2393765313444698,-2462.560957533982,-3804.889873501662) ",
    strokeWidth: 0,
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(1.0326606544719077,0,0,1.2393765313444698,-2462.560957533982,-3804.889873501662) ",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(1.0326606544719077,0,0,1.2393765313444698,-2462.560957533982,-3804.889873501662) ",
    id: "svg_7"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_11",
    fill: "#41479B",
    d: "m2797.942163,3068.088308l-435.31,0c-21.178,0 -38.345,17.167 -38.345,38.345l0,258.759c0,21.177 17.167,38.345 38.345,38.345l435.31,0c21.177,0 38.345,-17.167 38.345,-38.345l0,-258.759c0,-21.178 -17.167,-38.345 -38.345,-38.345z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_12",
    fill: "#F5F5F5",
    d: "m2835.756163,3100.094308c-3.022,-18.159 -18.797,-32.007 -37.814,-32.007l-9.977,0l-163.54,107.147l0,-107.146l-88.276,0l0,107.147l-163.54,-107.147l-9.977,0c-19.017,0 -34.792,13.847 -37.814,32.007l139.778,91.58l-140.309,0l0,88.276l140.309,0l-139.778,91.578c3.022,18.159 18.797,32.007 37.814,32.007l9.977,0l163.54,-107.147l0,107.147l88.276,0l0,-107.147l163.54,107.147l9.977,0c19.017,0 34.792,-13.847 37.814,-32.007l-139.778,-91.58l140.309,0l0,-88.276l-140.309,0l139.778,-91.579z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_13"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_14",
    fill: "#FF4B55",
    points: "2606.770088195801,3068.0881072878838 2553.804267883301,3068.0881072878838 2553.804267883301,3209.3293182253838 2324.287178039551,3209.3293182253838 2324.287178039551,3262.2951385378838 2553.804267883301,3262.2951385378838 2553.804267883301,3403.5363494753838 2606.770088195801,3403.5363494753838 2606.770088195801,3262.2951385378838 2836.287178039551,3262.2951385378838 2836.287178039551,3209.3293182253838 2606.770088195801,3209.3293182253838 "
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_15",
    fill: "#FF4B55",
    d: "m2349.080163,3401.064308l186.583,-121.114l-32.428,0l-169.724,110.172c4.153,4.847 9.49,8.645 15.569,10.942z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_16",
    fill: "#FF4B55",
    d: "m2670.675163,3279.950308l-32.428,0l180.716,117.305c5.057,-3.321 9.277,-7.807 12.287,-13.075l-160.575,-104.23z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_17",
    fill: "#FF4B55",
    d: "m2328.336163,3089.287308l157.73,102.387l32.428,0l-178.732,-116.02c-4.799,3.572 -8.726,8.242 -11.426,13.633z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_18",
    fill: "#FF4B55",
    d: "m2656.853163,3191.674308l170.035,-110.375c-4.199,-4.831 -9.578,-8.607 -15.699,-10.86l-186.764,121.235l32.428,0z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbp);
export default __webpack_public_path__ + "static/media/GBP.f226ec6944ec81d09f90b9fb022955de.svg";
export { ForwardRef as ReactComponent };